import { CALL_API } from 'middlewares/api';
import { url } from 'configs/';
import { clone, keyBy } from 'lodash';
import axios from 'axios';

const { NEWTUBE_API_SERVER } = url;
const INIT = 'tube/app/application/INIT';
const INIT_SUCCESS = 'tube/app/application/INIT_SUCCESS';
const INIT_FAIL = 'tube/app/application/INIT_FAIL';
const FETCH_LOGIN_STATUS_SUCCESS =
  'tube/app/application/FETCH_LOGIN_STATUS_SUCCESS';
const SET_PROGRESS = 'tube/app/application/SET_PROGRESS';
const FETCH_COMPANY_SETTINGS_REQUEST =
  'tube/app/application/FETCH_COMPANY_SETTING_REQUEST';
const FETCH_COMPANY_SETTINGS_SUCCESS =
  'tube/app/application/FETCH_COMPANY_SETTING_SUCCESS';
const SET_MESSAGE = 'tube/app/application/SET_MESSAGE';
const RESET_MESSAGE = 'tube/app/application/RESET_MESSAGE';
const SET_INIT_USER_LOCALE_IN_STORE =
  'tube/app/application/SET_INIT_USER_LOCALE_IN_STORE';

const FETCH_LOCALE_FILE_REQUEST =
  'tube/app/application/FETCH_LOCALE_FILE_REQUEST';
const FETCH_LOCALE_FILE_SUCCESS =
  'tube/app/application/FETCH_LOCALE_FILE_SUCCESS';
const FETCH_LOCALE_FILE_FAIL = 'tube/app/application/FETCH_LOCALE_FILE_FAIL';
const FETCH_LANGUAGE_REQUEST = 'tube/app/application/FETCH_LANGUAGE_REQUEST';
const FETCH_LANGUAGE_SUCCESS = 'tube/app/application/FETCH_LANGUAGE_SUCCESS';
const FETCH_LANGUAGE_FAIL = 'tube/app/application/FETCH_LANGUAGE_FAIL';
const FETCH_ANONYMOUS_LANGUAGE_REQUEST =
  'tube/app/application/FETCH_ANONYMOUS_LANGUAGE_REQUEST';
const FETCH_ANONYMOUS_LANGUAGE_SUCCESS =
  'tube/app/application/FETCH_ANONYMOUS_LANGUAGE_SUCCESS';
const FETCH_ANONYMOUS_LANGUAGE_FAIL =
  'tube/app/application/FETCH_ANONYMOUS_LANGUAGE_FAIL';
const FETCH_COMPANY_CONFIGURATION_SUCCESS =
  'tube/app/application/FETCH_COMPANY_CONFIGURATION_SUCCESS';
const FETCH_COMPANY_CONFIGURATION_REQUEST =
  'tube/app/application/FETCH_COMPANY_CONFIGURATION_REQUEST';
const FETCH_COMPANY_CONFIGURATION_FAIL =
  'tube/app/application/FETCH_COMPANY_CONFIGURATION_FAIL';

const SET_OTHER_ACCOUNT_LOGIN_STATUS =
  'tube/app/application/SET_OTHER_ACCOUNT_LOGIN_STATUS';
const SET_SIDEBAR_DISPLAY = 'tube/app/application/SET_SIDEBAR_DISPLAY';
const HEADER_COLOR_CODE = 'HeaderColor';
const COMPANY_LOGO_CODE = 'CompanyLogo';
const SHOW_PRIVACY = 'ShowPrivacy';

export const themeCodes = {
  companyLogo: COMPANY_LOGO_CODE,
  headerColor: HEADER_COLOR_CODE,
};

export default function reducer(
  state = {
    isLoaded: false,
    moduleType: undefined,
    locale: 'zh-tw',
    accessToken: undefined,
    isLoggedIn: false,
    progresses: [],
    locales: [],
    localeMessage: undefined,
    theme: {
      companyLogo: null,
      headerColor: null,
    },
    showPrivacy: true,
    message: {
      content: '',
      title: '',
      onConfirm: undefined,
      onCancel: undefined,
    },
    imported: undefined,
    isPreviewMode: false,
    isSidebarDisplay: false,
    bannerCarouselSeconds: 10,
    isOtherAccountLoggedIn: false,
    companyConfigurationItem: [],
  },
  action
) {
  switch (action.type) {
    case INIT_SUCCESS:
      return Object.assign({}, state, {
        isLoaded: true,
      });
    case FETCH_LOGIN_STATUS_SUCCESS:
      return Object.assign({}, state, { isLoggedIn: true });
    case SET_PROGRESS:
      const progresses = clone(state.progresses ? state.progresses : []);
      let isExist = false;
      for (let idx = progresses.length - 1; idx >= 0; idx--) {
        const progress = progresses[idx];
        if (progress.key === action.key) {
          isExist = true;
          if (action.progress === -1) {
            progresses.splice(idx, 1);
          } else {
            progress.progress = action.progress;
          }
        }
      }

      if (!isExist) {
        progresses.push({
          key: action.key,
          progress: action.progress,
          color: action.color,
        });
      }

      return Object.assign({}, state, { progresses });
    case FETCH_COMPANY_CONFIGURATION_SUCCESS:
      return Object.assign({}, state, {
        companyConfigurationItem: keyBy(action.response.data, 'code'),
      });
    case FETCH_COMPANY_SETTINGS_SUCCESS:
      const theme = Object.assign({}, state.theme);
      const data = keyBy(action.response.data, 'code');
      const themeConfigItems = [
        { key: 'companyLogo', defaultValue: null },
        { key: 'headerColor', defaultValue: '#26ABE3' },
      ];
      themeConfigItems.forEach(({ key, defaultValue }) => {
        theme[key] =
          (data[themeCodes[key]] && data[themeCodes[key]].stringValue) ||
          defaultValue;
      });
      return Object.assign({}, state, {
        theme,
        showPrivacy:
          data[themeCodes.showPrivacy] !== undefined
            ? data[themeCodes.showPrivacy].boolValue
            : true,
      });
    case SET_MESSAGE: {
      const message = Object.assign({}, state.message, {
        content: action.content,
        title: action.title,
        onConfirm: action.onConfirm,
        onCancel: action.onCancel,
      });
      return Object.assign({}, state, {
        message,
      });
    }
    case RESET_MESSAGE: {
      const message = Object.assign({}, state.message, {
        content: '',
        title: '',
        onConfirm: undefined,
        onCancel: undefined,
      });
      return Object.assign({}, state, {
        message,
      });
    }
    case FETCH_LOCALE_FILE_SUCCESS:
      return Object.assign({}, state, {
        localeMessage: action.response,
        locale: action.locale,
        headers: {
          'Accept-Language': action.locale,
        },
      });
    case FETCH_LOCALE_FILE_FAIL:
      return Object.assign({}, state, {
        localeMessage: {},
      });
    case FETCH_LANGUAGE_SUCCESS: {
      const resp = action.response.data;
      const locales = resp.map((p) => ({
        code: p.code,
        name: p.languageName,
      }));
      const result = Object.assign({}, state, {
        locales,
      });
      return result;
    }
    case SET_OTHER_ACCOUNT_LOGIN_STATUS:
      return Object.assign({}, state, {
        isOtherAccountLoggedIn: true,
      });
    case SET_SIDEBAR_DISPLAY:
      return Object.assign({}, state, {
        isSidebarDisplay: action.isSidebarDisplay,
      });
    case SET_INIT_USER_LOCALE_IN_STORE:
      return Object.assign({}, state, {
        locale: action.locale,
        headers: {
          'Accept-Language': action.locale,
        },
      });
    default:
      return state;
  }
}

export function setProgress(key, progress, color) {
  return (dispatch) => {
    if (progress >= 100) {
      setTimeout(() => {
        dispatch({
          type: SET_PROGRESS,
          key,
          progress: -1,
        });
      }, 500);
    }
    dispatch({
      type: SET_PROGRESS,
      key,
      progress,
      color,
    });
  };
}
export function fetchCompanySettings() {
  const code = Object.values(themeCodes);
  code.push(SHOW_PRIVACY);
  return {
    [CALL_API]: {
      url: NEWTUBE_API_SERVER + 'CompanyConfigurationItem',
      method: 'POST',
      params: {
        code,
      },
      types: [
        FETCH_COMPANY_SETTINGS_REQUEST,
        FETCH_COMPANY_SETTINGS_SUCCESS,
        INIT_FAIL,
      ],
    },
  };
}

export function getLoginStatus() {
  return (dispatch) =>
    dispatch({
      type: FETCH_LOGIN_STATUS_SUCCESS,
    });
}

export function setInitUserLocaleInStore(locale) {
  return (dispatch) => {
    dispatch({
      type: SET_INIT_USER_LOCALE_IN_STORE,
      locale,
    });
  };
}

export function loadLocalFile(moduleType, locale) {
  if (moduleType !== undefined && locale !== undefined) {
    return {
      [CALL_API]: {
        url: `/assets/dist/foundation/${moduleType}.${locale}.json`,
        method: 'GET',
        types: [
          FETCH_LOCALE_FILE_REQUEST,
          FETCH_LOCALE_FILE_SUCCESS,
          FETCH_LOCALE_FILE_FAIL,
        ],
        shouldCamelizedJson: false,
      },
      locale,
    };
  }

  return { type: 'NOTHING_TODO' };
}

export function switchLocale(locale) {
  return () => {
    axios
      .put(`${NEWTUBE_API_SERVER}User/Language`, {
        language: locale,
      })
      .then((res) => {
        const validLocale = res.data.data.language;
        localStorage.setItem('locale', validLocale);
        sessionStorage.locale = validLocale;
        window.location.reload();
      });
  };
}

export function fetchLanguage() {
  return {
    [CALL_API]: {
      url: NEWTUBE_API_SERVER + 'companyParameters/CompanyLanguage',
      method: 'GET',
      types: [
        FETCH_LANGUAGE_REQUEST,
        FETCH_LANGUAGE_SUCCESS,
        FETCH_LANGUAGE_FAIL,
      ],
    },
  };
}
export function fetchAnonymousLanguage() {
  return {
    [CALL_API]: {
      url: NEWTUBE_API_SERVER + 'anonymous/DefaultLanguage/GetAll',
      method: 'GET',
      types: [
        FETCH_ANONYMOUS_LANGUAGE_REQUEST,
        FETCH_ANONYMOUS_LANGUAGE_SUCCESS,
        FETCH_ANONYMOUS_LANGUAGE_FAIL,
      ],
    },
  };
}

export function fetchCompanyConfiguration() {
  return {
    [CALL_API]: {
      url:
        NEWTUBE_API_SERVER + '/Shared/CompanyConfiguration/Module/foundation',
      method: 'GET',
      types: [
        FETCH_COMPANY_CONFIGURATION_REQUEST,
        FETCH_COMPANY_CONFIGURATION_SUCCESS,
        FETCH_COMPANY_CONFIGURATION_FAIL,
      ],
    },
  };
}

export function init() {
  return (dispatch, getState) => {
    const {
      app: {
        application: { locale, moduleType, isLoggedIn },
      },
    } = getState();

    const actions = [
      {
        dispatchMethod: loadLocalFile.bind(null, moduleType, locale),
      },
    ];
    if (isLoggedIn) {
      actions.push(
        {
          dispatchMethod: fetchLanguage.bind(null, dispatch, getState),
        },
        {
          dispatchMethod: fetchCompanySettings,
        },
        {
          dispatchMethod: fetchCompanyConfiguration,
        }
      );
    } else {
      actions.push({
        dispatchMethod: fetchAnonymousLanguage.bind(null, dispatch, getState),
      });
    }

    const progressKey = 'INIT_APPLICATION_INFO';

    const progressStep = 80 / actions.length;
    let initedActionCount = 0;

    dispatch({
      type: INIT,
    });

    dispatch(setProgress(progressKey, 20, '#3072AB'));

    actions.forEach((action) => {
      dispatch(action.dispatchMethod()).then(
        () => {
          initedActionCount += 1;
          if (initedActionCount === actions.length) {
            dispatch(setProgress(progressKey, 100));
            dispatch({
              type: INIT_SUCCESS,
            });
          } else {
            dispatch(
              setProgress(progressKey, 20 + initedActionCount * progressStep)
            );
          }
        },
        () => {
          initedActionCount += 1;
        }
      );
    });
  };
}

export function setSidebarDisplay(isSidebarDisplay) {
  return {
    type: SET_SIDEBAR_DISPLAY,
    isSidebarDisplay,
  };
}

export function resetMessage() {
  return {
    type: RESET_MESSAGE,
  };
}

export function setMessage(title, content, onConfirm, onCancel) {
  return {
    type: SET_MESSAGE,
    title,
    content,
    onConfirm,
    onCancel,
  };
}



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/containers/App/reducers/applicationReducer.js
 **/